module.exports = __webpack_public_path__ + "static/media/cities.f83034de.png";